
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";
interface PurchaseProfile {
  investorId: number;
  profileName: string;
  firstName: string;
  lastName: string;
  isDeleted: boolean;
  isDefault: boolean;
  userType: "individual" | "business";  // Assuming the userType will be either "individual" or "business"
}

interface PurchaseProfileResponse {
  body: PurchaseProfile[];
  statusCode: number;
  message: string | null;
}

interface PurchaseProfileState {
  profiles: PurchaseProfileResponse;  // List of Purchase Profiles
  loading: boolean;
  error: string;
}

const initialState: PurchaseProfileState = {
  profiles: {
    body: [],
    "statusCode": 0,
    "message": null
  },
  loading: false,
  error: "",
};

// Async thunk for fetching properties
// Assuming fetchpropertylist is an API function that returns property data
export const FetchProfileList = createAsyncThunk<any,string|number>(
  "purchaseProfile/FetchProfileList",
  async (investorId, { rejectWithValue }) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `/investor/purchase-profile/${investorId}`,
      }
      const response = await handleFetchApi(params);
      const profiles = response.data;  // Adjust based on actual API response
      return profiles;
    } catch (error: any) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


const purchaseProfileListSlice = createSlice({
  name: 'purchaseProfileList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchProfileList.pending, (state) => {
        state.loading = true;
      })
      .addCase(FetchProfileList.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload; // Store the assets (properties)
      })
      .addCase(FetchProfileList.rejected, (state, action) => {
        state.loading = false;
        state.error = "Error fetching properties"; // Store the error message
      });
  },
});

export default purchaseProfileListSlice.reducer;

